import React from "react";

import { FindingsFilters } from "@pages/findings/types";

interface IFindingFiltersContext {
  findingFilters: FindingsFilters;
  setFindingFilters: (filters: FindingsFilters) => void;
}
export const FindingFiltersContext =
  React.createContext<IFindingFiltersContext>({
    findingFilters: {},
    setFindingFilters: () => {
      throw new Error("FindingsFiltersContext not initialized");
    },
  });

export const FindingFiltersProvider: React.FC = ({ children }) => {
  const [findingFilters, setFindingFilters] = React.useState<FindingsFilters>(
    {}
  );

  return (
    <FindingFiltersContext.Provider
      value={{ findingFilters, setFindingFilters }}
    >
      {children}
    </FindingFiltersContext.Provider>
  );
};
